<div #baseDialog>
</div>
